import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import { useEffect, useState } from 'react';

export function ProtectedRoute() {
  const { isAuthenticated, isLoading, checkAuth, user } = useAuthStore();
  const [checking, setChecking] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const verify = async () => {
      await checkAuth();
      setChecking(false);
    };
    verify();
  }, [checkAuth]);

  if (checking || isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Verificando sesión...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const isEnvioRole = user?.rol?.nombre === 'Envíos' || user?.role === 'envios' || user?.rolId === 2;
  const currentPath = location.pathname;

  if (isEnvioRole && !currentPath.startsWith('/envios-repartidor')) {
    return <Navigate to="/envios-repartidor" replace />;
  }

  if (!isEnvioRole && currentPath.startsWith('/envios-repartidor')) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}